"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationContract = void 0;
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../schemas");
const organization_request_1 = require("./organization.request");
const organization_response_1 = require("./organization.response");
const c = (0, core_1.initContract)();
exports.OrganizationContract = c.router({
    find: {
        method: 'GET',
        path: '/',
        responses: {
            200: organization_response_1.CompanyGetResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    update: {
        method: 'PATCH',
        path: '/',
        body: organization_request_1.UpdateCompanyRequestSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
        },
    },
}, { pathPrefix: '/organization' });
